var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#434343"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5002 19.9997L19.5002 21.9997L23.5002 17.9997M27.1668 19.9997C27.1668 23.6816 24.1821 26.6663 20.5002 26.6663C16.8183 26.6663 13.8335 23.6816 13.8335 19.9997C13.8335 16.3178 16.8183 13.333 20.5002 13.333C24.1821 13.333 27.1668 16.3178 27.1668 19.9997Z",
    stroke: "#2EC99E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcons);
export default __webpack_public_path__ + "static/media/check-Icons.880acb0d3ba5572cd6676f804d86951c.svg";
export { ForwardRef as ReactComponent };